export const environnementLimits: { [key: string]: { min: number; max: number } } = {
  iqa: {
    min: 30,
    max: 100
  },
  '€/m²': {
    min: 100,
    max: 3000
  },
  default: {
    min: 0,
    max: 100
  }
};
